import { render, staticRenderFns } from "./edittask.vue?vue&type=template&id=5ea31d66"
import script from "./edittask.vue?vue&type=script&lang=tsx"
export * from "./edittask.vue?vue&type=script&lang=tsx"
import style0 from "./edittask.vue?vue&type=style&index=0&id=5ea31d66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports